import { makeStyles } from "@material-ui/core/styles";
import { createTheme } from "@material-ui/core/styles";
import Colors from "../../../../../utils/Colors";

const useStyles = makeStyles((theme) => ({
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(1000 + theme.spacing(2) * 2)]: {
      width: 1000,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },

  container: {
    display: "flex",
    width: "100%",
    backgroundColor: Colors.WHITE,
    paddingLeft: 10,
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  gridRow: {
    display: "flex",
  },
  transferListContainer: {
    height: 230,
    overflow: "auto",
    border: "1px solid " + Colors.SILVER_SAND,
    borderRadius: 5,
  },
  buttonPanel: {
    margin: theme.spacing(0.5, 0),
    textTransform: "none",
  },
  cardHeader: {
    padding: theme.spacing(1, 2),
  },
  transferListBox: {
    width: "43%",
  },
  transferListMiddle: {
    width: "14%",
  },
  widthFull: {
    width: "100%",
  },
  helpIcon: {
    alignSelf: "center",
    marginLeft: 10,
  },
  card: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(1),
  },
}));

const transferList = createTheme({
  palette: {
    primary: {
      main: Colors.OLIVE,
    },
  },
  overrides: {
    MuiListItem: {
      dense: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
});

export { useStyles, transferList };
